import { sendIt } from 'gatsby-plugin-purina-analytics/common/functions';

/**
 *
 * @param containerRef - The ref of the container that contains the links
 * @description This function processes the links in the container and attaches click event listeners to them.
 * The click event listeners send analytics data to the server.
 * It also returns a function that removes the event listeners when called.
 * Should be used inside of an useEffect hook.
 * @returns
 */
export const processAndAttachLinkTracking = (containerRef: React.RefObject<HTMLDivElement>) => {
  if (typeof window === 'undefined' || !containerRef.current) {
    return () => {};
  }

  const handleContainerClick = (event: MouseEvent) => {
    let target = event.target as HTMLElement;
    while (target && target !== containerRef.current) {
      if (target.tagName === 'A') {
        const linkElement = target as HTMLAnchorElement;

        const linkText = linkElement.textContent || '[not set]';

        let linkUrl = linkElement.href || '[not set]';
        try {
          const url = new URL(linkUrl);
          linkUrl = url.hostname + url.pathname;
        } catch (e) {
          // eslint-disable-next-line no-console
          console.error('Error parsing URL', e);
        }

        sendIt({
          event: 'select_content',
          eventParams: {
            content_name: linkText,
            content_type: 'inline_link',
            link_url: linkUrl,
          },
        });

        break;
      }

      target = target.parentElement as HTMLElement;
    }
  };

  containerRef.current.addEventListener('click', handleContainerClick);

  return () => {
    if (containerRef.current) {
      containerRef.current.removeEventListener('click', handleContainerClick);
    }
  };
};
